<script>
import Layout from '@layouts/main-header'
import Loading from 'vue-loading-overlay'
import DeviceStateHistoryDetailTimeline from '@components/vis-device-state-history-detail-timeline'
import DeviceStateHistoryDetailCycle from '@components/vis-device-state-history-detail-cycle-list'
import DeviceStateHistoryDetailShift from '@components/vis-device-state-history-detail-shift'
import DeviceStateHistoryDetailState from '@components/vis-device-state-history-detail-state'

import {
  deviceInsightsMethods,
  deviceInsightsComputed,
  deviceInsightsDataComputed,
  filtersComputed,
  infoMethods,
} from '@state/helpers'

export default {
  components: {
    Layout,
    Loading,
    DeviceStateHistoryDetailTimeline,
    DeviceStateHistoryDetailCycle,
    DeviceStateHistoryDetailShift,
    DeviceStateHistoryDetailState,
  },

  data() {
    return {
      timelineInstanceKey: 0,
      fetchInterval: null,
      mouseMove: false,
      mouseMoveInterval: null,
    }
  },

  computed: {
    ...deviceInsightsComputed,
    ...deviceInsightsDataComputed,
    ...filtersComputed,

    firstDeviceStateAggregateHourDevice: function() {
      let deviceStateAggregateHourDevice = [
        ...(this.cachedDeviceStateAggregateHourDevice || []),
      ].shift()

      if (deviceStateAggregateHourDevice) {
        return deviceStateAggregateHourDevice.deviceStateAggregateHour
      } else return deviceStateAggregateHourDevice
    },
  },

  watch: {
    dateRangeWebFilters() {
      this.fetch(false)
    },

    activityChangedFilter() {
      this.fetch(true)
      this.timelineInstanceKey = this.timelineInstanceKey + 1
    },

    cachedDeviceEvents() {
      this.timelineInstanceKey = this.timelineInstanceKey + 1
    },
  },

  created: function() {
    this.fetchInterval = setInterval(() => {
      if (!this.mouseMove && this.changedDeviceActivities.length < 1) {
        this.fetch()
      }
    }, 120000)

    window.addEventListener('mousemove', (e) => {
      this.mouseMoveInterval = null

      if (this.mouseMove === false) {
        this.mouseMoveInterval = setTimeout(() => {
          this.mouseMove = false
        }, 59000)
      }
      this.mouseMove = true
    })
  },

  beforeDestroy() {
    clearInterval(this.fetchInterval)
  },

  methods: {
    ...infoMethods,
    ...deviceInsightsMethods,

    fetch: function(noCache) {
      this.getDeviceEvents({
        clearCache: true,
        dateRange: this.dateRangeWebFilters,
        deviceId: this.$route.params.deviceId,
        noCache: noCache,
      })

      this.getDeviceStateAggregateHour({
        clearCache: true,
        dateRange: this.dateRangeWebFilters,
        deviceId: this.$route.params.deviceId,
      })
    },
  },
}
</script>

<template>
  <Layout>
    <template v-slot:header>
      <DeviceStateHistoryDetailState />
    </template>

    <div v-if="cachedDeviceEvents.length > 0">
      <Loading
        :active.sync="loading"
        :is-full-page="true"
        loader="bars"
        background-color="#3c3c3c"
      />

      <b-row v-if="cachedDeviceEvents" class="pb-3">
        <b-col lg="12">
          <DeviceStateHistoryDetailTimeline
            :key="timelineInstanceKey"
            :device-events="cachedDeviceEvents"
            :conditions="cachedDeviceConditions"
            :cycles="cachedDeviceCycles"
            :activities="cachedDeviceActivities"
          />
        </b-col>
      </b-row>

      <b-row class="pb-3">
        <b-col v-if="cachedDeviceEvents" lg="8">
          <DeviceStateHistoryDetailCycle
            :cached-device-event-cycles="cachedDeviceEventsSortedCycleAsArrayObjects"
          />
        </b-col>

        <b-col v-if="cachedDeviceEvents && firstDeviceStateAggregateHourDevice" lg="4">
          <DeviceStateHistoryDetailShift
            :cached-device-events="cachedDeviceEvents"
            :cached-device-state-aggregate-hour-device="
              firstDeviceStateAggregateHourDevice
            "
          />
        </b-col>
      </b-row>
    </div>

    <b-card v-else :no-body="true" class="p-4 text-center">
      <h4> <i class="icon-question"></i> No Events</h4>
    </b-card>
  </Layout>
</template>
